export default "__VITE_ASSET__BNcKkrkg__"